import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  actionsMobile: {
    position: 'sticky',
    bottom: 0,
    padding: theme.spacing(2, 0),
    justifyContent: 'flex-end',
    zIndex: theme.zIndex.appBar,
  },
  actionsDesktop: {
    order: '-1',
    minHeight: 50,
  },
  actionsCheckbox: {
    margin: theme.spacing(0, 2),
  },
  actionsButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${fade(theme.palette.primary.main, 0.16)}`,
    [theme.breakpoints.down('xs')]: {
      boxShadow: theme.shadows[2],
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
    '&:active': {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.primary.lighter,
    },
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        boxShadow: `4px 4px 0 ${theme.palette.secondary.light}`,
      },
    },
  },
  actionsFab: {
    flex: '0 0 auto',
  },
  pagination: {
    marginRight: 'auto',
  },
}))

export default useStyles
